(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3_buy_now_ribbon"] && !window.DesignMode) return;
  try {
    
  window.drawer_manual = false;

  document.getElementById('drawer_close').addEventListener('click', function () {
    window.drawer_manual = true;

    const stickyCTA = document.querySelector('.sticky_cta');
    const drawerCloseText = document.getElementById('drawer_close_text');

    if (stickyCTA.classList.contains('closed')) {
      stickyCTA.classList.remove('closed');
      drawerCloseText.textContent = 'Hide';
    } else {
      stickyCTA.classList.add('closed');
      drawerCloseText.textContent = 'Show';
    }
  });

  const observer = new IntersectionObserver(
    (entries) => {
      const isButtonVisible = entries[0].isIntersecting;
      const stickyCTA = document.querySelector('.sticky_cta');
      const drawerCloseText = document.getElementById('drawer_close_text');
      const isMobile = window.innerWidth <= 768;
      const hasScrolledPast50vh = window.scrollY > window.innerHeight * 0.5;

      if (
        !isButtonVisible &&
        stickyCTA.classList.contains('closed') &&
        !window.drawer_manual &&
        (!isMobile || hasScrolledPast50vh)
      ) {
        stickyCTA.classList.remove('closed');
        drawerCloseText.textContent = 'Hide';
      } else if (isButtonVisible && !stickyCTA.classList.contains('closed') && !window.drawer_manual) {
        stickyCTA.classList.add('closed');
        drawerCloseText.textContent = 'Show';
      }
    },
    { threshold: 0.5 }
  );

  const addToCartButtonContainer = document.getElementById('add__to__cart__button__container');
  observer.observe(addToCartButtonContainer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3_product_preview"] && !window.DesignMode) return;
  try {
    
  document.querySelectorAll('.swatch__container').forEach((swatch) => {
    swatch.addEventListener('click', (e) => {
      const img = e.currentTarget.getAttribute('data-img');
      const url = e.currentTarget.getAttribute('data-product-url');
      document.querySelector('[data-image-type="featured"]').src = img;
      document.querySelector('.product__preview .primary-button').href = url;
      document.querySelectorAll('.swatch__container').forEach((swatch) => {
        swatch.classList.remove('active');
      });
      e.currentTarget.classList.add('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3_product_recs"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product__rec').forEach((productRec) => {
      productRec.addEventListener('click', (event) => {
        event.preventDefault();
        const variantId = productRec.getAttribute('data-variant-id');

        // Show loading state on product card
        productRec.classList.add('loading');

        // Use Shopify's AJAX API to add the item to cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
              },
            ],
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            // After adding to cart, fetch the cart-drawer section with the updated cart
            fetch(window.location.pathname + '?section_id=cart-drawer')
              .then((response) => response.text())
              .then((responseText) => {
                // Also get cart-icon-bubble for updating the cart count
                fetch(window.location.pathname + '?section_id=cart-icon-bubble')
                  .then((response) => response.text())
                  .then((iconResponse) => {
                    // Find the cart drawer and call its renderContents method
                    const cartDrawer = document.querySelector('cart-drawer');
                    if (cartDrawer) {
                      // Structure data for renderContents - pass the complete HTML strings
                      cartDrawer.renderContents({
                        id: variantId,
                        sections: {
                          'cart-drawer': responseText,
                          'cart-icon-bubble': iconResponse,
                        },
                      });
                    }
                  })
                  .catch((error) => console.error('Error fetching cart icon:', error));
              })
              .catch((error) => console.error('Error fetching cart drawer:', error));
          })
          .catch((error) => {
            console.error('Error adding product to cart:', error);
          })
          .finally(() => {
            productRec.classList.remove('loading');
          });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
